<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    {{ $t("stockouts.title") }}
    <span v-show="!c1 && !c2">&nbsp;</span>

    <br v-show="c1" />

    <button
      class="button"
      @click="$emit('get-stockouts')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <button
      class="button"
      @click="$emit('download-report')"
      style="display: inline-block; margin-left: 1rem;"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="save"></b-icon>
    </button>

    <br v-show="c2" />

    <span
      :style="
        c1
          ? 'position: relative; top: -0.1rem;'
          : 'position: relative; top: -1.1rem;'
      "
    >
      &nbsp;
      <b-datepicker
        style="width: 210px; display: inline-block;"
        placeholder="Selecione o período..."
        v-model="dates"
        range
        @input="$emit('update-dates', dates)"
        :mobile-native="false"
      ></b-datepicker>
    </span>
    <hr />
  </h1>
</template>

<script>
import { common } from "../../mixins/common";
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  mixins: [common, responsive],

  components: {
    goToDashboardButton
  },

  data() {
    return {
      dates: null
    };
  },

  computed: {
    c1() {
      return this.windowWidth < 700;
    },
    c2() {
      return this.windowWidth < 370;
    }
  },

  mounted() {
    this.dates = [new Date(), new Date()];
  }
};
</script>

<style scoped>
.inline {
  display: inline;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
